import { JSONSchemaType } from 'ajv'

export interface IProfileFormData {
  name: string
  password: string
}

const ProfileSchema: JSONSchemaType<IProfileFormData> = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    password: {
      type: 'string',
      minLength: 8,
      errorMessage: 'Senha deve possuir no mínimo 5 caracteres',
    },
  },
  required: ['name', 'password'],
  additionalProperties: false,
}

export default ProfileSchema
